<template>
  <div style="overflow: auto;">
    <div class="bank-list">
      <van-search class="search-ipt" shape="round" v-model="value" placeholder="请输入开户行名称搜索" @search="handleSearch"
        @input="handleInput" @blur="handleBlur" />
      <div class="list text-l" v-if="bankList.length">
        <div class="list-item flex flex-ac" v-for="item in bankList" :key="item.code" @click="handleChecked(item)">
          <div class="bank-info flex-1 flex flex-fc flex-jc">
            <div class="bank-name">
              <span v-html="formatBankName(item.name)"></span>
            </div>
            <div class="bank-num">联行号：{{ item.code }}</div>
          </div>
          <van-icon name="arrow" color="#BEBEBE" size="0.6rem" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGetBankList } from '@/api/dq';
import { Toast } from 'vant';
export default {
  data() {
    return {
      value: '',
      bankList: [],
      query: {},
    };
  },
  methods: {
    handleBlur() {
      window.scroll(0, 0)
    },
    formatBankName(str) {
      return str
        ? str.replace(
          this.value,
          `<span style="color:#FF6F00">${this.value}</span>`
        )
        : '';
    },
    getList() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
      });
      apiGetBankList(this.value).then((res) => {
        if (res.status !== 200) {
          this.bankList = [];
          this.$toast(res.message);
          return;
        }
        this.bankList = res.data.list;
        Toast.clear();
      });
    },
    handleSearch() {
      this.getList();
    },
    handleInput(value) {
      if (value.trim()) {
        clearInterval(this.timer);
        this.timer = setTimeout(() => {
          this.value = value;
          this.getList();
        }, 400);
      }
    },
    handleChecked(item) {
      let registInfo = JSON.parse(localStorage.getItem('registInfo'));
      registInfo = {
        ...registInfo,
        unionpayNo: item.code,
        bankOpen: item.name,
      };
      localStorage.setItem('registInfo', JSON.stringify(registInfo));
      this.$router.replace({
        path: '/dq/regist',
      });
      window.history.back(-1);
    },
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
@import url('./dq.global.less');

.bank-list {
  line-height: 1;
  background: #f3f5f6;
  border: 1px solid #f3f5f6;
  box-sizing: border-box;
  font-family: PingFangSC-Regular, PingFang SC;
  padding-top: 65px;
  overflow: auto;

  .search-ipt {
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    box-sizing: border-box;
    z-index: 999;
    // padding: 10px 10px;
    border-radius: 0px 0px 10px 10px;
    background: #fff;

    .van-search__content.van-search__content--round {
      border: 1px solid #fff;
    }

    .search-ipt {
      padding: 10px;

      /deep/.van-search__content {
        padding-left: 12px;
      }

      /deep/.van-cell {
        padding: 10px 8px 10px 0;
      }

      /deep/.van-field__control {
        width: 100%;
        height: 24px;
      }
    }
  }

  .list {
    flex: 1;
    padding: 0 12px 12px 12px;
    overflow: auto;
    box-sizing: border-box;

    .list-item {
      margin-top: 12px;
      background: #fff;
      padding: 16px 12px;
      border-radius: 8px;

      .bank-info {
        .bank-name {
          font-size: 16px;
          font-weight: 500;
          color: #111111;
        }

        .bank-num {
          font-size: 12px;
          font-weight: 400;
          color: #666666;
          margin-top: 10px;
        }
      }
    }
  }
}

.notice {
  color: #FF6F00;
}
</style>